import styled from "styled-components";
import { Table } from "antd";

export const CustomTitle = styled.span`
    font-size: 16px;
    color: #000000E0;
    line-height: 1.38;
    padding: 0;
    font-family: "Roboto", "Roboto-Medium" !important;
`;

export const CustomCell = styled.div`
    font-size: 15px;
    font-weight: 500;
    color: #2e333e;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const StyledTable = styled(Table)`
    .ant-table-thead > tr > th {
        background-color: white;
    }
    
    .ant-empty-description {
        padding: 50px;
    }

    .ant-table-cell.ant-table-selection-column.ant-table-cell-fix-left{
        background-color: white !important;
    }

    .ant-table-cell.ant-table-cell-scrollbar{
        background-color: white !important;
    }

    .ant-pagination-options {
        display: none;
    }

	background-color: white !important;
	height: 100%;

`;

